module.exports = __webpack_public_path__ + "static/media/R-180HD_CrossSection.70cab9b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/de/R-180HD_CrossSection.png
// module id = 469
// module chunks = 0